import styled from 'react-emotion';
import { themeGet } from 'styled-system';
import { FlexCol, FlexRow } from '../misc';

// @margin
export const PaymentElement = styled('div')`
  box-shadow: 0 1px 3px 0 rgba(50, 50, 93, 0.15),
    0 4px 6px rgba(112, 157, 199, 0.15);
  border-radius: 4px;
  padding: ${themeGet('space.2')}px ${themeGet('space.4')}px;
  border: ${props =>
    props.hasFocus
      ? '0.7px solid rgba(28,61,90,1)'
      : '0.7px solid rgba(218, 225, 231, 1)'};
  transition: all 0.2s ease-in;
  height: 48px;
`;
export const PaymentElementWrapper = styled(PaymentElement)`
  width: ${props => (props.fullWidth ? '100%' : '50%')};
`;

export const PaymentElementHeading = styled('h3')`
  font-size: 14px;
  font-weight: 300;
  color: ${props =>
    props.hasFocus
      ? themeGet('colors.blueDarker')
      : themeGet('colors.greyDarker')};
  padding: ${themeGet('space.1')}px ${themeGet('space.4')}px;
  transition: color 0.2s ease-in;
`;

export const CardIconWrapper = styled(FlexRow)`
  justify-content: flex-end;
  align-items: center;
  padding: 0 ${themeGet('space.4')}px;

  svg:last-child {
    margin-left: ${themeGet('space.1')}px;
  }
`;

export const CheckoutDividingHeading = styled('h3')`
  margin-bottom: 25px;
  color: rgba(96, 111, 123, 1);
  font-weight: 400;
  text-transform: uppercase;
  font-size: 16px;
  letter-spacing: 0.1px;
  position: relative;
  z-index: 1;
  width: max-content;

  &:after {
    content: '';
    display: block;
    height: 50%;
    left: 5px;
    right: 0;
    position: absolute;
    width: calc(100% + 15px);
    background-color: ${themeGet('colors.greyLight')};
    opacity: 0.8;
    bottom: -2px;
    z-index: -1;
    transform: skewX(-20deg);
  }
`;

export const Wrapper = styled(FlexCol)`
  max-width: 480px;
  margin: 0 auto;
  width: 100%;
  height: 100%;
  @media screen and (min-width: 40em) and (max-width: 52em), (min-width: 76em) {
    max-width: 620px;
    padding: ${themeGet('space.4')}px;
  }
`;

export const FormContainer = styled('div')`
  position: relative;
  width: 100%;
  border-radius: 4px;
  border: 2px solid ${themeGet('colors.greyLight')};
  background: white;
  overflow-y: scroll;
  padding: ${themeGet('space.4')}px;

  @media screen and (min-width: 72em) {
    min-height: 620px;
    padding: ${themeGet('space.5')}px;
  }
`;

export const CardStyle = {
  base: {
    fontSize: '16px',
    fontFamily: 'Lato,sans-serif',
    color: 'rgba(28,61,90,1)',
    lineHeight: 2,
    '::placeholder': {
      fontSize: '16px',
      color: 'rgba(135,149,161,1)',
      fontWeight: '300',
    },
    iconColor: '#3490DC',
  },
};



// WEBPACK FOOTER //
// ./src/components/payment/style.js